// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"7857623a","234":"74b3314c"}[chunkId] + ".js";
};